import { Button, ButtonGroup } from "react-bootstrap"

export enum ChartRange {
  All = "All",
  ThreeMonth = "3M",
  OneMonth = "1M",
}

const RANGE_OPTIONS = [ChartRange.All, ChartRange.ThreeMonth, ChartRange.OneMonth]

const RANGE_MS: Record<ChartRange, number | null> = {
  [ChartRange.All]: null,
  [ChartRange.ThreeMonth]: 90 * 24 * 60 * 60 * 1000,
  [ChartRange.OneMonth]: 30 * 24 * 60 * 60 * 1000,
}

export function filterSeriesByRange<T extends { name: string; data: [number, number][] }>(
  series: T[] | undefined,
  range: ChartRange,
): T[] | undefined {
  if (!series || range === ChartRange.All) return series

  const latestTimestamp = series.reduce((latest, networkSeries) => {
    for (const [timestamp] of networkSeries.data) {
      if (timestamp > latest) return timestamp
    }
    return latest
  }, 0)

  if (latestTimestamp === 0) return series

  const rangeDuration = RANGE_MS[range]!
  const cutoffTimestamp = latestTimestamp - rangeDuration

  return series.map((networkSeries) => ({
    ...networkSeries,
    data: networkSeries.data.filter(([timestamp]) => timestamp >= cutoffTimestamp),
  }))
}

interface ChartRangeSelectorProps {
  value: ChartRange
  onChange: (range: ChartRange) => void
}

export const ChartRangeSelector = ({ value, onChange }: ChartRangeSelectorProps) => (
  <ButtonGroup size="sm">
    {RANGE_OPTIONS.map((range) => (
      <Button
        key={range}
        variant={value === range ? "primary" : "outline-primary"}
        onClick={() => onChange(range)}
      >
        {range}
      </Button>
    ))}
  </ButtonGroup>
)
